// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"Loading_loadingOverlay__+BgPJ"};